module.exports = __webpack_public_path__ + "front/img/zzs01.37960e07.png";